// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
We have added !important to the css property because we are editing already existing buttons from Shopify.
Shopify uses special buttons for buying the product which has the whole form linked to it - used as component and cannot be edited.
Given that the properties cannot be changed we had to find an way to change it. Also we had to add ::before and ::after because
of the loading. If we dont we can see colors jumping so all 3 properties have to be set.
*/
.product-form__item--payment-button .add-to-bag-buttons {
  color: var(--add-button-color) !important;
  background: var(--add-button-backgroundcolor) !important;
}
.product-form__item--payment-button .add-to-bag-buttons::before {
  background: var(--add-button-backgroundcolor) !important;
}
.product-form__item--payment-button .add-to-bag-buttons::after {
  background: var(--add-button-backgroundcolor) !important;
}
.product-form__item--payment-button .product-buy-buttons button {
  height: 48px;
  color: var(--buy-button-color) !important;
  background: var(--buy-button-backgroundcolor) !important;
  border-radius: var(--buy-button-round-option, 0) !important;
}
.product-form__item--payment-button .product-buy-buttons button::before {
  background: var(--buy-button-backgroundcolor) !important;
}
.product-form__item--payment-button .product-buy-buttons button::after {
  background: var(--buy-button-backgroundcolor) !important;
}
.product-form__item--payment-button .product-buy-buttons .shopify-payment-button .shopify-payment-button__button.shopify-payment-button__button--branded {
  height: 48px;
}

.wrapper-background {
  width: 100%;
  background-color: #fff;
  color: #000;
  z-index: 20;
  display: none;
  position: fixed;
  left: 50%;
  bottom: -1px;
  transform: translate(-50%, 0);
  transition: all 0.25s ease-in-out;
  transition: color 0.2s ease, border-color 0.2s ease;
  border-top: 2px solid #000;
}
@media (max-width: 1500px) {
  .wrapper-background {
    width: 100%;
  }
}
.wrapper-background .sticky-add-to-bag-button-container {
  margin: auto;
  padding: 0 var(--space-outer);
  width: calc(var(--max-width) + var(--space-outer) * 2);
  max-width: calc(var(--max-width) + var(--space-outer) * 2);
  gap: 14px;
  align-items: center;
  background-color: transparent;
}
@media (max-width: 480px) {
  .wrapper-background .sticky-add-to-bag-button-container {
    bottom: 0;
    width: 95%;
    max-width: 95%;
    padding: 0 5px;
  }
}
.wrapper-background .sticky-add-to-bag-button-container .content-aligment-container {
  padding-top: 5px;
  width: 100%;
  display: flex;
}
@media (max-width: 480px) {
  .wrapper-background .sticky-add-to-bag-button-container .content-aligment-container {
    flex-direction: column;
  }
}
.wrapper-background .sticky-add-to-bag-button-container .content-aligment-container .container-content {
  display: flex;
  margin-left: 10px;
}
@media (max-width: 480px) {
  .wrapper-background .sticky-add-to-bag-button-container .content-aligment-container .container-content {
    margin-left: 0;
    margin-bottom: 5px;
  }
}
.wrapper-background .sticky-add-to-bag-button-container .content-aligment-container .container-content .title-container {
  margin: auto 0 auto 10px;
  text-align: center;
}
@media (max-width: 480px) {
  .wrapper-background .sticky-add-to-bag-button-container .content-aligment-container .container-content .title-container {
    margin: auto;
  }
}
.wrapper-background .sticky-add-to-bag-button-container .content-aligment-container .container-content img {
  width: 65px;
  height: 65px;
}
@media (max-width: 480px) {
  .wrapper-background .sticky-add-to-bag-button-container .content-aligment-container .container-content img {
    margin: auto;
  }
}
.wrapper-background .sticky-add-to-bag-button-container button {
  max-height: 48px;
  width: 420px;
  margin: auto 10px auto auto;
}
@media (max-width: 480px) {
  .wrapper-background .sticky-add-to-bag-button-container button {
    width: 280px;
    margin: auto;
  }
}

footer {
  z-index: 21;
}

.manuals-download {
  margin: 10px 0 20px;
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--color-border);
  padding-top: var(--spacing-4);
}
.manuals-download h3 {
  padding-bottom: 16px;
}
.manuals-download ul {
  margin: 0;
}
.manuals-download ul li {
  margin: 5px 0;
}
.manuals-download ul li a {
  color: #193c72;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/product.bundle/styles/buy-buttons.scss"],"names":[],"mappings":"AAAA;;;;;CAAA;AAOE;EACE,yCAAA;EACA,wDAAA;AAAJ;AAEI;EACE,wDAAA;AAAN;AAGI;EACE,wDAAA;AADN;AAMI;EACE,YAAA;EACA,yCAAA;EACA,wDAAA;EACA,2DAAA;AAJN;AAMM;EACE,wDAAA;AAJR;AAOM;EACE,wDAAA;AALR;AASI;EACE,YAAA;AAPN;;AAYA;EACE,WAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,6BAAA;EACA,iCAAA;EACA,mDAAA;EACA,0BAAA;AATF;AAWE;EAdF;IAeI,WAAA;EARF;AACF;AAUE;EACE,YAAA;EACA,6BAAA;EACA,sDAAA;EACA,0DAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;AARJ;AAUI;EATF;IAUI,SAAA;IACA,UAAA;IACA,cAAA;IACA,cAAA;EAPJ;AACF;AASI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AAPN;AASM;EALF;IAMI,sBAAA;EANN;AACF;AAQM;EACE,aAAA;EACA,iBAAA;AANR;AAQQ;EAJF;IAKI,cAAA;IACA,kBAAA;EALR;AACF;AAOQ;EACE,wBAAA;EACA,kBAAA;AALV;AAOU;EAJF;IAKI,YAAA;EAJV;AACF;AAOQ;EACE,WAAA;EACA,YAAA;AALV;AAOU;EAJF;IAKI,YAAA;EAJV;AACF;AASI;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;AAPN;AASM;EALF;IAMI,YAAA;IACA,YAAA;EANN;AACF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,6BAAA;AARF;AAUE;EACE,oBAAA;AARJ;AAWE;EACE,SAAA;AATJ;AAWI;EACE,aAAA;AATN;AAWM;EACE,cAAA;EACA,0BAAA;AATR","sourcesContent":["/*\nWe have added !important to the css property because we are editing already existing buttons from Shopify.\nShopify uses special buttons for buying the product which has the whole form linked to it - used as component and cannot be edited.\nGiven that the properties cannot be changed we had to find an way to change it. Also we had to add ::before and ::after because\nof the loading. If we dont we can see colors jumping so all 3 properties have to be set.\n*/\n.product-form__item--payment-button {\n  .add-to-bag-buttons {\n    color: var(--add-button-color) !important;\n    background: var(--add-button-backgroundcolor) !important;\n\n    &::before {\n      background: var(--add-button-backgroundcolor) !important;\n    }\n\n    &::after {\n      background: var(--add-button-backgroundcolor) !important;\n    }\n  }\n\n  .product-buy-buttons {\n    button {\n      height: 48px;\n      color: var(--buy-button-color) !important;\n      background: var(--buy-button-backgroundcolor) !important;\n      border-radius: var(--buy-button-round-option, 0) !important;\n\n      &::before {\n        background: var(--buy-button-backgroundcolor) !important;\n      }\n\n      &::after {\n        background: var(--buy-button-backgroundcolor) !important;\n      }\n    }\n\n    .shopify-payment-button .shopify-payment-button__button.shopify-payment-button__button--branded {\n      height: 48px;\n    }\n  }\n}\n\n.wrapper-background {\n  width: 100%;\n  background-color: #fff;\n  color: #000;\n  z-index: 20;\n  display: none;\n  position: fixed;\n  left: 50%;\n  bottom: -1px;\n  transform: translate(-50%, 0);\n  transition: all .25s ease-in-out;\n  transition: color .2s ease, border-color .2s ease;\n  border-top: 2px solid #000;\n\n  @media (max-width: 1500px) {\n    width: 100%;\n  }\n\n  .sticky-add-to-bag-button-container {\n    margin: auto;\n    padding: 0 var(--space-outer);\n    width: calc(var(--max-width) + calc(var(--space-outer) * 2));\n    max-width: calc(var(--max-width) + calc(var(--space-outer) * 2));\n    gap: 14px;\n    align-items: center;\n    background-color: transparent;\n\n    @media (max-width: 480px) {\n      bottom: 0;\n      width: 95%;\n      max-width: 95%;\n      padding: 0 5px;\n    }\n\n    .content-aligment-container {\n      padding-top: 5px;\n      width: 100%;\n      display: flex;\n\n      @media (max-width: 480px) {\n        flex-direction: column;\n      }\n\n      .container-content {\n        display: flex;\n        margin-left: 10px;\n\n        @media (max-width: 480px) {\n          margin-left: 0;\n          margin-bottom: 5px;\n        }\n\n        .title-container {\n          margin: auto 0 auto 10px;\n          text-align: center;\n\n          @media (max-width: 480px) {\n            margin: auto;\n          }\n        }\n\n        img {\n          width: 65px;\n          height: 65px;\n\n          @media (max-width: 480px) {\n            margin: auto;\n          }\n        }\n      }\n    }\n\n    button {\n      max-height: 48px;\n      width: 420px;\n      margin: auto 10px auto auto;\n\n      @media (max-width: 480px) {\n        width: 280px;\n        margin: auto;\n      }\n    }\n  }\n}\n\nfooter {\n  z-index: 21;\n}\n\n.manuals-download {\n  margin: 10px 0 20px;\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid var(--color-border);\n  padding-top: var(--spacing-4);\n\n  h3 {\n    padding-bottom: 16px;\n  }\n\n  ul {\n    margin: 0;\n\n    li {\n      margin: 5px 0;\n\n      a {\n        color: #193c72;\n        text-decoration: underline;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
